/* Progressive enhancement. Original full reviews remain readable without JS. */
(function () {
  'use strict';
  function initialize(scope) {
    scope.querySelectorAll('.fitouch-native-reviews').forEach(function (section) {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      var cards = Array.from(section.querySelectorAll('.fitouch-native-review'));
      cards.forEach(function (card) {
        var excerpt = card.querySelector('.fitouch-native-review__excerpt');
        var body = card.querySelector('.fitouch-native-review__body');
        var toggle = card.querySelector('.fitouch-native-review__toggle');
        if (!excerpt || !body || !toggle) return;
        body.hidden = true;
        excerpt.hidden = false;
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') !== 'true';
          body.hidden = !expanded;
          excerpt.hidden = expanded;
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? 'Read Less' : 'Read More';
          toggle.setAttribute('aria-label', (expanded ? 'Read less: ' : 'Read more: ') + card.querySelector('h3').textContent);
        });
      });
      var visible = Math.min(4, cards.length);
      var more = section.querySelector('.fitouch-native-reviews__more');
      var moreButton = more.querySelector('button');
      function render() {
        cards.forEach(function (card, index) { card.hidden = index >= visible; });
        more.hidden = visible >= cards.length;
      }
      render();
      moreButton.addEventListener('click', function () {
        var firstNew = cards[visible];
        visible = Math.min(visible + 4, cards.length);
        render();
        section.querySelector('.fitouch-native-reviews__status').textContent = 'Showing ' + visible + ' selected reviews.';
        // Keep keyboard focus useful when the last Load More disappears.
        if (more.hidden && firstNew) {
          var nextButton = firstNew.querySelector('.fitouch-native-review__toggle:not([hidden])');
          if (nextButton) nextButton.focus({ preventScroll: true });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
